const config = {
  proofread: {
    schoolColor: 'blue',
    customerColor: 'red',
  },

  updateTopicsURL: 'https://appx.co.jp/topics/',
  maxUploadPhotoCount:20,

  cautionLoadInterval: 1800000, // 30分ごとに注意表示の再読み込み
};
export default config;